"use client";

import useStore from "@/lib/stateManagement/persistedState/persistedStore";
import { useSelection } from "@frend-digital/centra/client";

export const useShippingMethods = () => {
  const local_token = useStore(state => state.token);
  const { data: selection, isLoading, isFetching, refetch } = useSelection();

  const changeShippingMethod = async (shippingMethod: string) => {
    if (!local_token) {
      console.error("Missing customer token key");
      throw new Error("Missing customer token key");
    }
    const apiUrl = process.env.NEXT_PUBLIC_CENTRA_CHECKOUT;
    if (window.CentraCheckout) window.CentraCheckout.suspend();
    const res = await fetch(`${apiUrl}/shipping-methods/${shippingMethod}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "API-Token": local_token || "",
      },
    });
    const data = await res.json();
    if (window.CentraCheckout) window.CentraCheckout.resume();
    refetch();
    return data;
  };

  return {
    isLoading,
    isFetching,
    shippingMethods: selection?.shippingMethods,
    currentShippingMethod: selection?.selection?.shippingMethod,
    changeShippingMethod,
  };
};
